import { Component, OnInit, ElementRef, Input, OnChanges, SimpleChanges } from '@angular/core';
import echarts from 'echarts';
import { formatNumber } from '../../../../shared/utils/common';

@Component({
  selector: 'app-fans-interest',
  templateUrl: './fans-interest.component.html',
  styleUrls: ['./fans-interest.component.less'],
})
export class FansInterestComponent implements OnInit, OnChanges {
  constructor(private el: ElementRef) {}

static NAME = 'icc-msg-social-fans-interest';

  // 图谱实例
  chartIns: any;
  colorList = ['#58d3ff', '#34a2ff', '#23d3a0', '#91ef7a', '#fbbb15', '#fb7649', '#e9ef00', '#7e85e6'];

  pieData: Array<{
    name: string; // 兴趣名称
    value: string; // 粉丝数量
    ratio: string; // 粉丝比例
  }>;

  // 数据源
  @Input() data: Array<{
    item: string; // 兴趣名称
    value: number; // 粉丝数量
  }>;

  chartData: any = [];

  // 排名列表
  rankList: Array<{
    name: string; // 兴趣名称
    value: string; // 粉丝数
    ratio: string; // 占比
  }>;

  // 自适应函数
  resizeCharts = () => {
    if (this.chartIns) {
      this.chartIns.resize();
    }
  };

  ngOnInit() {
    window.addEventListener('resize', this.resizeCharts);
  }

  ngOnChanges(changes: SimpleChanges) {
    if (this.data instanceof Array && this.data.length) {
      /* this.pieData = this.formatPieData(this.data); */
      this.data.forEach(item => {
        const temp: any = {};
        temp.name = item.item;
        temp.value = item.value;
        this.chartData.push(temp);
      });
      this.rankList = [];
      this.getRank();
      setTimeout(() => {
        this.createLineChart('chart-el');
      }, 0);
    }
  }

  ngOnDestroy() {
    if (this.chartIns) {
      this.chartIns.dispose();
      this.chartIns = null;
    }
    window.removeEventListener('resize', this.resizeCharts);
  }

  // 数据处理
  formatPieData(data) {
    const result = [];
    let sub = 0;
    data.forEach((item: any) => {
      sub = sub + item.value;
    });
    data.forEach((item: any) => {
      const temp: any = {};
      temp.name = item.item;
      temp.value = formatNumber(item.value);
      const radioBefore = Number((item.value / sub).toFixed(2)) * 100;
      temp.ratio = radioBefore.toFixed(0) + '%';
      result.push(temp);
    });
    return result;
  }

  // 获取粉丝数量前五名
  getRank() {
    let tempData = this.data.sort((a, b) => b.value - a.value);
    this.rankList = this.formatPieData(tempData).splice(0, 5);
  }

  /* 生成图谱 */
  createLineChart(chartCls) {
    const elCollection = this.el.nativeElement.getElementsByClassName(chartCls);
    if (!this.chartIns && elCollection.length) {
      this.chartIns = echarts.init(elCollection[0]);
    }
    this.chartIns.setOption({
      tooltip: {
        trigger: 'item',
        formatter: '{b} : {c}',
      },
      legend: {
        show: true,
        bottom: '10%',
      },
      series: [
        {
          type: 'pie',
          color: this.colorList,
          radius: '42%',
          center: '50%',
          roseType: false,
          label: {
            normal: {
              formatter: params => {
                return '{b| ' + params.name + '}  ' + '{c|' + params.percent.toFixed(0) + '%}';
              },
              borderWidth: 0,
              borderRadius: 4,
              padding: [0, -80, 0, -80],
              height: 30,
              fontSize: 12,
              align: 'center',
              color: '#9ea8c8',
              rich: {},
            },
          },
          labelLine: {
            length1: 20,
            length2: 80,
            lineStyle: {
              color: '#eaecf0',
            },
          },
          data: this.chartData,
        },
      ],
    });
  }
}
